/* Product media: load only visible videos, preserving the image as fallback. */
(()=>{
  const watched=new Set();
  const play=video=>{
    if(document.hidden||!video.isConnected)return;
    video.muted=true;video.defaultMuted=true;
    if(!video.getAttribute('src')&&video.dataset.gVideoSrc){video.src=video.dataset.gVideoSrc;video.load()}
    const attempt=video.play();if(attempt)attempt.catch(()=>{});
  };
  const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{
    target.dataset.gVideoVisible=isIntersecting?'1':'0';
    if(isIntersecting)play(target);else target.pause();
  }),{threshold:0.15});
  function scan(scope){
    const videos=[...(scope.matches?.('video[data-g-product-video]')?[scope]:[]),...scope.querySelectorAll('video[data-g-product-video]')];
    videos.forEach(video=>{
      if(watched.has(video))return;watched.add(video);
      video.muted=true;video.defaultMuted=true;video.controls=false;video.playsInline=true;
      video.addEventListener('playing',()=>video.classList.add('is-playing'));
      video.addEventListener('error',()=>{video.classList.remove('is-playing');video.pause()});
      observer.observe(video);
    });
  }
  scan(document);
  new MutationObserver(records=>{
    records.forEach(r=>r.addedNodes.forEach(n=>{if(n.nodeType===1)scan(n)}));
    watched.forEach(video=>{if(!video.isConnected){video.pause();observer.unobserve(video);watched.delete(video)}});
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>watched.forEach(video=>{
    if(document.hidden)video.pause();else if(video.dataset.gVideoVisible==='1')play(video);
  }));
  document.addEventListener('pointerdown',()=>watched.forEach(video=>{
    if(video.paused&&video.dataset.gVideoVisible==='1')play(video);
  }),{passive:true});
})();
